import React, { useMemo } from 'react'
import { Text } from 'components/atoms'
import PropTypes from 'prop-types'

const FieldMaxLetters = ({ value, maxLetters }) => {
  const numberOfLetters = typeof value === 'string' ? value.length : null
  const info = `${numberOfLetters}/${maxLetters}`;

  const isOverMaxLetter = useMemo(() => {
    if (typeof maxLetters === 'number' && typeof numberOfLetters === 'number') return numberOfLetters > maxLetters;
    return false;
  }, [maxLetters, numberOfLetters]);

  if (typeof value !== 'string') return null
  if (isOverMaxLetter) return <Text modifiers={['danger']}>{info}</Text>;
  return <Text modifiers={['light']}>{info}</Text>;
}

FieldMaxLetters.propTypes = {
  value: PropTypes.string.isRequired,
  maxLetters: PropTypes.number,
}

FieldMaxLetters.defaultProps = {
  maxLetters: null,
}

export default FieldMaxLetters
